import React from 'react';
import { Link } from 'react-router-dom';
import { Card } from './../../components/card/card.jsx';
import { Icon } from '@iconify/react';

function PagesProducts() {
	return (
		<div>
			<div className="d-flex align-items-center mb-3">
				<div>
					<ul className="breadcrumb">
						<li className="breadcrumb-item"><a href="#/">PAGES</a></li>
						<li className="breadcrumb-item active">PRODUCTS</li>
					</ul>
					<h1 className="page-header mb-0">Products</h1>
				</div>
				
				<div className="ms-auto">
					<a href="#/" className="btn btn-theme btn-sm w-130px py-2 fs-11px d-flex align-items-center justify-content-center">
						<Icon icon="material-symbols-light:add" className="fs-22px me-1 ms-n3 my-n3" />
						ADD PRODUCT
					</a>
				</div>
			</div>
			
			<div className="d-flex">
				<div className="mb-sm-4 mb-3 d-sm-flex">
					<div className="mt-sm-0 mt-2 me-2"><a href="#/" className="text-body text-decoration-none d-flex align-items-center"><Icon icon="material-symbols-light:download-sharp" className="fs-20px opacity-5 me-2 my-n1" /> Export</a></div>
					<div className="ms-sm-4 mt-sm-0 mt-2 me-2"><a href="#/" className="text-body text-decoration-none d-flex align-items-center"><Icon icon="material-symbols-light:upload-sharp" className="fs-20px opacity-5 me-2 my-n1" /> Import</a></div>
					<div className="ms-sm-4 mt-sm-0 mt-2 me-2 dropdown-toggle">
						<a href="#/" data-bs-toggle="dropdown" className="text-body text-decoration-none">More Actions</a>
						<div className="dropdown-menu">
							<a className="dropdown-item" href="#/">Action</a>
							<a className="dropdown-item" href="#/">Another action</a>
							<a className="dropdown-item" href="#/">Something else here</a>
							<div role="separator" className="dropdown-divider"></div>
							<a className="dropdown-item" href="#/">Separated link</a>
						</div>
					</div>
				</div>
			</div>
			
			<Card>
				<ul className="nav nav-tabs nav-tabs-v2 small text-uppercase mb-4 px-2">
					<li className="nav-item me-4"><a href="#allTab" className="nav-link active px-2 py-2" data-bs-toggle="tab">All</a></li>
					<li className="nav-item me-4"><a href="#publishedTab" className="nav-link px-2 py-2" data-bs-toggle="tab">Published</a></li>
					<li className="nav-item me-4"><a href="#expiredTab" className="nav-link px-2 py-2" data-bs-toggle="tab">Expired</a></li>
					<li className="nav-item me-4"><a href="#deletedTab" className="nav-link px-2 py-2" data-bs-toggle="tab">Deleted</a></li>
				</ul>
				<div className="tab-content">
					<div className="tab-pane fade show active" id="allTab">
						<div className="input-group mb-4">
							<button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">Filter Products&nbsp;</button>
							<div className="dropdown-menu">
								<a className="dropdown-item" href="#/">Action</a>
								<a className="dropdown-item" href="#/">Another action</a>
								<a className="dropdown-item" href="#/">Something else here</a>
								<div role="separator" className="dropdown-divider"></div>
								<a className="dropdown-item" href="#/">Separated link</a>
							</div>
							<div className="flex-fill position-relative z-1">
								<div className="input-group">
									<div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0">
										<i className="fa fa-search opacity-5"></i>
									</div>
									<input type="text" className="form-control ps-30px" placeholder="Enter product name" />
								</div>
							</div>
						</div>
						
						<div className="table-responsive">
							<table className="table table-hover text-nowrap small mb-4">
								<thead>
									<tr>
										<th></th>
										<th>PRODUCT</th>
										<th>INVENTORY</th>
										<th>TYPE</th>
										<th>VENDOR</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product1" />
												<label className="form-check-label" htmlFor="product1"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-6.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Force Majeure White T Shirt</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">83 in stock for 3 variants</td>
										<td className="align-middle">Cotton</td>
										<td className="align-middle">Force Majeure</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product2" />
												<label className="form-check-label" htmlFor="product2"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-7.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Eco-friendly fashion, organic cotton, slow fashion polo shirts</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">79 in stock for 3 variants</td>
										<td className="align-middle">Cotton</td>
										<td className="align-middle">Polo</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product3" />
												<label className="form-check-label" htmlFor="product3"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-8.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Nike Shoes (Red Color)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">19 in stock for 1 variants</td>
										<td className="align-middle">Sports</td>
										<td className="align-middle">Nike</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product4" />
												<label className="form-check-label" htmlFor="product4"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-9.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Nike Air Max (Blue Color)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">19 in stock for 1 variants</td>
										<td className="align-middle">Sports</td>
										<td className="align-middle">Nike</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product5" />
												<label className="form-check-label" htmlFor="product5"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-10.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Skate Sneaker (Orange Color)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">19 in stock for 1 variants</td>
										<td className="align-middle">Sports</td>
										<td className="align-middle">Skate</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product6" />
												<label className="form-check-label" htmlFor="product6"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-11.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Teen Fashion T-shirt (Black)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">30 in stock for 4 variants</td>
										<td className="align-middle">T-Shirt</td>
										<td className="align-middle">Tulsa</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product7" />
												<label className="form-check-label" htmlFor="product7"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-12.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Levis Blue Jeans</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">49 in stock for 8 variants</td>
										<td className="align-middle">Jeans</td>
										<td className="align-middle">Levis</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product8" />
												<label className="form-check-label" htmlFor="product8"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-13.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Boots (White Color)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">19 in stock for 1 variants</td>
										<td className="align-middle">Sports</td>
										<td className="align-middle">Nike</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product9" />
												<label className="form-check-label" htmlFor="product9"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-14.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Hiking Boots</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">94 in stock for 1 variants</td>
										<td className="align-middle">Sports</td>
										<td className="align-middle">Skate</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product10" />
												<label className="form-check-label" htmlFor="product10"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-15.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Dress (Pink)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">23 in stock for 5 variants</td>
										<td className="align-middle">Dress</td>
										<td className="align-middle">Sktoe</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product11" />
												<label className="form-check-label" htmlFor="product11"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-17.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Sunglasses (Black)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">15 in stock for 3 variants</td>
										<td className="align-middle">Accessories</td>
										<td className="align-middle">SunCo</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product12" />
												<label className="form-check-label" htmlFor="product12"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-18.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Running Shoes (Blue)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">45 in stock for 7 variants</td>
										<td className="align-middle">Footwear</td>
										<td className="align-middle">RunFast</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product13" />
												<label className="form-check-label" htmlFor="product13"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-19.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Leather Jacket (Black)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">8 in stock for 2 variants</td>
										<td className="align-middle">Jacket</td>
										<td className="align-middle">LeatherCo</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product14" />
												<label className="form-check-label" htmlFor="product14"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-20.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Smartwatch (Silver)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">20 in stock for 4 variants</td>
										<td className="align-middle">Electronics</td>
										<td className="align-middle">TechTime</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product15" />
												<label className="form-check-label" htmlFor="product15"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-21.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Handbag (Brown)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">25 in stock for 3 variants</td>
										<td className="align-middle">Bags</td>
										<td className="align-middle">FashionBag</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product16" />
												<label className="form-check-label" htmlFor="product16"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-22.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Wireless Earbuds (White)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">30 in stock for 5 variants</td>
										<td className="align-middle">Electronics</td>
										<td className="align-middle">AudioTech</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product17" />
												<label className="form-check-label" htmlFor="product17"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-23.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Blender (Red)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">12 in stock for 2 variants</td>
										<td className="align-middle">Home Appliance</td>
										<td className="align-middle">KitchenPro</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product18" />
												<label className="form-check-label" htmlFor="product18"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-24.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Gaming Console (Black)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">18 in stock for 3 variants</td>
										<td className="align-middle">Electronics</td>
										<td className="align-middle">GameOn</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product19" />
												<label className="form-check-label" htmlFor="product19"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-25.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">Wristwatch (Gold)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">10 in stock for 2 variants</td>
										<td className="align-middle">Accessories</td>
										<td className="align-middle">TimeKeeper</td>
									</tr>
									<tr>
										<td className="w-10px align-middle px-3">
											<div className="form-check">
												<input type="checkbox" className="form-check-input" id="product20" />
												<label className="form-check-label" htmlFor="product20"></label>
											</div>
										</td>
										<td>
											<div className="d-flex align-items-center">
												<img alt="" className="object-fit-cover w-30px h-30px" src="/quantum-react/assets/img/product/product-26.jpg" />
												<div className="ms-3">
													<Link to="/pages/product-details" className="text-body text-opacity-75 text-decoration-none">T-shirt (White)</Link>
												</div>
											</div>
										</td>
										<td className="align-middle">50 in stock for 6 variants</td>
										<td className="align-middle">Clothing</td>
										<td className="align-middle">Wearable</td>
									</tr>
								</tbody>
							</table>
						</div>
						
						<div className="d-md-flex align-items-center">
							<div className="me-md-auto text-md-left text-center mb-2 mb-md-0">
								Showing 1 to 20 of 57 entries
							</div>
							<ul className="pagination mb-0 justify-content-center">
								<li className="page-item disabled"><a className="page-link" href="#/">Previous</a></li>
								<li className="page-item"><a className="page-link" href="#/">1</a></li>
								<li className="page-item active"><a className="page-link" href="#/">2</a></li>
								<li className="page-item"><a className="page-link" href="#/">3</a></li>
								<li className="page-item"><a className="page-link" href="#/">4</a></li>
								<li className="page-item"><a className="page-link" href="#/">5</a></li>
								<li className="page-item"><a className="page-link" href="#/">6</a></li>
								<li className="page-item"><a className="page-link" href="#/">Next</a></li>
							</ul>
						</div>
					</div>
				</div>
			</Card>
		</div>
	)
}

export default PagesProducts;